import { ApolloError } from '@apollo/client'
import { apolloErrorParser } from '@src/utils/apolloErrorParser/apolloErrorParser'

// Extendable to other client errors as needed
export const useCustomClientErrorHandler = () => {
  const isPostcodeOrAddressError = (error: ApolloError) => {
    const parsedError = apolloErrorParser(error)
    const isLocationError = parsedError.customClientErrors.some(err =>
      [
        'POSTCODE_NOT_FOUND',
        'ADDRESS_NOT_FOUND',
        'ADDRESS_UNAVAILABLE',
      ].includes(err.data.errorResolutionType)
    )

    return { isLocationError, parsedError }
  }

  return { isPostcodeOrAddressError }
}
